import { useAccount } from 'wagmi';
import { extractAddress } from '../helper';
import { TRON_PLATFORM_TYPE } from '../../../../Constants/MainKeys';
import { useEffect } from 'react';
import ApiService from '../../../../Services/ApiService';
import { useParams } from 'react-router-dom';
import AlertService from '../../../../Services/AlertService';
// import { useAppKitAccount } from '@reown/appkit/react';

const WalletConnectWalletInfo = ({ selectedChain, selectedToken, allBalance }) => {

  const { token } = useParams();
  // Early return if Tron network is selected
  if (selectedChain?.platformType === TRON_PLATFORM_TYPE) {
    return null;
  }

  // navsyaki
  // const { address, isConnected, caipAddress, status, embeddedWalletInfo } = useAppKitAccount();
  const { address, isConnected } = useAccount();

  // useEffect(() => {
  //   if (isConnected && token) {
  //     onWalletConnected();
  //   }
  // }, [isConnected, token])

  // const onWalletConnected = () => {
  //   ApiService.onWalletConnected(token).then(() => { }).catch(error => AlertService.alert("error", error))
  // }

  return (
    <>
      {
        isConnected && <div className="info-block">
          <div className="text-muted text-nowrap">Status</div>
          <div className="dotes w-100" />
          <div className="text-success capitalize">Connected</div>
        </div>
      }
      {
        address && <div className="info-block mt-2">
          <div className="text-muted text-nowrap">Address</div>
          <div className="dotes w-100" />
          <div className="text-muted capitalize">{extractAddress(address)}</div>
        </div>
      }
      {
        selectedChain && <div className="info-block mt-2">
          <div className="text-muted text-nowrap">Network</div>
          <div className="dotes w-100" />
          <div className="text-muted text-nowrap">
            {
              selectedChain ?
                <div className="d-flex gap-2 align-items-center">
                  <span>{selectedChain.chainName}</span>
                  <img src={selectedChain.chainLogo} width={20} className="rounded" />
                </div>
                : "Not set"
            }
          </div>
        </div>
      }
      {
        allBalance && <div className="info-block mt-2">
          <div className="text-muted text-nowrap">Amount</div>
          <div className="dotes w-100" />
          <div className="text-muted text-nowrap">
            {
              selectedToken ?
                <div className="d-flex gap-2 align-items-center">
                  <span>{allBalance?.balance}</span>
                  <img src={allBalance.currencyLogo} width={20} className="rounded" />
                </div>
                : "Not set"
            }
          </div>
        </div>
      }
    </>

  );
}

export default WalletConnectWalletInfo
